module.exports = __webpack_public_path__ + "img/icons_bi-dir.60516064.svg";